import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f3d027ca"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "address-title"
}, "填写收货信息", -1));
const _hoisted_2 = {
  class: "form-buttons"
};
import { ref, watch } from "vue";
export default {
  __name: 'custom_address',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    initialAddress: {
      type: Object,
      default: () => ({
        receiver: "",
        phone: "",
        address: ""
      })
    }
  },
  emits: ["update:show"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const visible = ref(props.show);
    const addressForm = ref({
      receiver: "",
      phone: "",
      address: ""
    });

    // 添加Promise相关变量
    let resolvePromise = null;
    let rejectPromise = null;

    // 监听show属性变化
    watch(() => props.show, val => {
      visible.value = val;
    });

    // 监听visible变化，通知父组件
    watch(visible, val => {
      emit("update:show", val);
    });

    // 监听初始地址变化
    watch(() => props.initialAddress, val => {
      if (val) {
        addressForm.value = {
          ...val
        };
      }
    }, {
      immediate: true,
      deep: true
    });

    // 打开弹窗的方法，返回Promise
    const open = (initialData = {}) => {
      // 如果有初始数据，设置表单值
      if (initialData) {
        addressForm.value = {
          ...initialData
        };
      }
      visible.value = true;

      // 返回Promise对象，实现阻断流程
      return new Promise((resolve, reject) => {
        resolvePromise = resolve;
        rejectPromise = reject;
      });
    };
    const handleClose = () => {
      visible.value = false;

      // 如果存在Promise回调，则拒绝Promise
      if (rejectPromise) {
        rejectPromise({
          type: "cancel"
        });
        resetPromiseHandlers();
      }
    };
    const submitForm = () => {
      const result = {
        ...addressForm.value
      };

      // 如果存在Promise回调，则解决Promise并传递结果
      if (resolvePromise) {
        resolvePromise(result);
        resetPromiseHandlers();
      }
      handleClose();
    };

    // 重置Promise处理器
    const resetPromiseHandlers = () => {
      resolvePromise = null;
      rejectPromise = null;
    };

    // 暴露给父组件的方法
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createBlock(_component_van_popup, {
        show: visible.value,
        "onUpdate:show": _cache[3] || (_cache[3] = $event => visible.value = $event),
        position: "bottom",
        round: "",
        closeable: "",
        "close-icon": "close",
        onClose: handleClose,
        "close-on-click-overlay": false
      }, {
        default: _withCtx(() => [_hoisted_1, _createVNode(_component_van_form, {
          onSubmit: submitForm
        }, {
          default: _withCtx(() => [_createVNode(_component_van_field, {
            modelValue: addressForm.value.receiver,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => addressForm.value.receiver = $event),
            name: "receiver",
            label: "收货人",
            placeholder: "请输入收货人姓名",
            autocomplete: "off",
            rules: [{
              required: true,
              message: '请填写收货人姓名'
            }],
            maxlength: "20"
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: addressForm.value.phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => addressForm.value.phone = $event),
            name: "phone",
            type: "tel",
            label: "手机号码",
            placeholder: "请输入收货人手机号码",
            autocomplete: "off",
            rules: [{
              required: true,
              message: '请填写手机号'
            }, {
              pattern: /^1[3-9]\d{9}$/,
              message: '手机号格式错误'
            }],
            maxlength: "11"
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: addressForm.value.address,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => addressForm.value.address = $event),
            name: "address",
            label: "收货地址",
            type: "textarea",
            autocomplete: "off",
            rows: "3",
            placeholder: "请输入详细收货地址",
            rules: [{
              required: true,
              message: '请填写收货地址'
            }],
            maxlength: "100",
            "show-word-limit": ""
          }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "info",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [_createTextVNode("确认")]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      }, 8, ["show"]);
    };
  }
};